module.exports = __webpack_public_path__ + "jobs-2ec46bc8/kununuLogo-95638cc24594e9ceb45321d65d915dd3.svg";